import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRiotGames: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="riot-games"><path d="M2.5 8.1122L13.1542 3.17828L21.5 5.26878V16.2077L18.0471 16.6317L16.6696 8.81874L16.0052 9.1143L16.6772 16.7999L13.1844 17.2293L11.9245 10.0851L11.2676 10.3774L11.8813 17.3889L8.42847 17.8128L7.2829 11.3191L6.61951 11.6147L7.17503 17.9671L5.15465 18.2152L2.5 8.1122Z" fill="currentColor"/><path d="M13.5803 19.4956L13.4045 18.501H13.4088L21.5 17.5065V20.8159L13.5803 19.4956Z" fill="currentColor"/></CentralIconBase>;
};

export default IconRiotGames;
